import { LabelHTMLAttributes } from 'react';
import { VariantProps } from 'tailwind-variants';
import { IsVisible } from '../../utils';
import { uploadButtonStyle } from './styles';

export interface IUploadButtonProps
  extends LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof uploadButtonStyle> {
  children?: React.ReactNode;
  disabled?: boolean;
  error?: string;
  filesAccepted?: string;
  inputRef?: React.LegacyRef<HTMLInputElement>;
  label?: string;
  maxLength?: number;
  multiple?: boolean;
  name?: string;
}

export function UploadButton({
  children,
  className,
  design,
  disabled = false,
  error,
  filesAccepted,
  inputRef,
  label,
  maxLength,
  multiple = false,
  name = 'uploadButtonInput',
  textTransform,
  ...rest
}: IUploadButtonProps) {
  return (
    <div>
      <label
        className={uploadButtonStyle({
          design,
          textTransform,
          disabled,
          errored: !!error,
          className,
        })}
        htmlFor={name}
        {...rest}
      >
        {children || label}
        <input
          accept={filesAccepted}
          className="hidden"
          disabled={disabled}
          id={name}
          max={maxLength}
          maxLength={maxLength}
          multiple={multiple}
          name={name}
          ref={inputRef}
          type="file"
        />
      </label>
      <IsVisible when={!!error}>
        <div className="flex mt-2 mx-auto w-fit">
          <span className="text-primary-two text-xs">{error}</span>
        </div>
      </IsVisible>
    </div>
  );
}
